<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <div *ngIf="currentUser">
    <table class="table" style="background-color:white;">
      <tr>
        <td style="background-color:#0f2b46;color:white;" colspan="2"> Create Corporate/Company Store </td>
        <td style="text-align: right;background-color: #0f2b46;color: white;padding-right: 32px;"><mat-icon [mat-dialog-close]="false">close</mat-icon></td>
      </tr>
    </table>

    <form (ngSubmit)="addmerchantstore(StoreForm.value)" [formGroup]="StoreForm">
      <mat-form-field>
        <mat-label>Select Country</mat-label>
        <mat-select formControlName="StoreCountryid" matTooltip="Select Country" autocomplete="off" required>
          <mat-form-field>
            <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
          </mat-form-field>
          <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.id">
            <img matSuffix [src]="d?.countryFlag" style="height: 20px;width: 20px;" />
            {{d?.name}}({{d?.isdCode}})
          </mat-option>
        </mat-select>
        <mat-error *ngIf="submitted && f.StoreCountryid.errors">
          Select Country
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input type="text" matInput placeholder="Enter Store Name" formControlName="storeName" maxlength="200" required />
        <mat-error *ngIf="submitted && f.storeName.errors">
          Enter Store Name
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input type="text" matInput placeholder="Enter Store Address" formControlName="storeAddress" maxlength="200" required />
        <mat-error *ngIf="submitted && f.storeAddress.errors">
          Enter Store Address
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input type="text" matInput placeholder="Enter Store City" formControlName="storeCity" maxlength="200" required />
        <mat-error *ngIf="submitted && f.storeCity.errors">
          Enter Store City
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <input type="text" matInput placeholder="Enter Store Description" formControlName="description" maxlength="200" required />
        <mat-error *ngIf="submitted && f.description.errors">
          Enter Store Description
        </mat-error>
      </mat-form-field>


      <button type="submit" mat-raised-button color="primary" >

        Submit
      </button>




    </form>
  </div>

</fieldset>

